import { IUser } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { address as addressUtils } from "@rentiohq/web-shared/dist/utils";
import { EField } from "./schema.profilePersonal.types";

export const getInitialValues = (user: IUser) => {
  const { personalContact } = user;
  if (!personalContact) {
    return;
  }

  let address = undefined;
  if (personalContact?.street) {
    address = {
      street: personalContact.street,
      number: personalContact.number,
      box: personalContact.box,
      zip: personalContact.zip,
      city: personalContact.city,
      state: personalContact.state,
      country: personalContact.countryId,
    };
  }

  return {
    [EField.FirstName]: user.firstname,
    [EField.LastName]: user.lastname,
    [EField.Email]: user.unverifiedEmail || user.email,
    [EField.MobileNumber]: user.unverifiedPhone || user.phone,
    [EField.Language]: user.locale,
    [EField.Address]: addressUtils.addressObjToString(address || {}),
    [EField.CountryId]: personalContact?.countryId,
    ...address,
  };
};
